import { FC, useState } from 'react'

import {
  AIAssistantConfigInitial,
  NavigationContext
} from './navigationContext'
import {
  AIAssistantAppConfigProps,
  CopilotState,
  FeedbackState,
  GdprState,
  LivechatState,
  NavigationContextProviderTypes,
  NotificationPaneState,
  NotificationState,
  SidebarContent
} from './navigationContext.types'

export const NavigationContextProvider: FC<NavigationContextProviderTypes> = ({
  children
}) => {
  const [sidebarContent, setSidebarContent] = useState<SidebarContent>(null)
  const [livechatState, setLivechatState] = useState<LivechatState>('closed')
  const [gdprState, setGdprState] = useState<GdprState>('closed')
  const [feedbackState, setFeedbackState] = useState<FeedbackState>('opened')
  const [copilotState, setCopilotState] = useState<CopilotState>('closed')
  const [AIAssistantConfig, setAIAssistantConfig] =
    useState<AIAssistantAppConfigProps>(AIAssistantConfigInitial)
  const [emailAppUnreadMessagesCount, setEmailAppUnreadMessagesCount] =
    useState<number>(0)
  const [notificationPaneState, setNotificationPaneState] =
    useState<NotificationPaneState>('closed')
  const [notificationState, setNotificationState] =
    useState<NotificationState>('opened')

  return (
    <NavigationContext.Provider
      value={{
        sidebarContent,
        setSidebarContent,
        livechatState,
        setLivechatState,
        gdprState,
        setGdprState,
        AIAssistantConfig,
        setAIAssistantConfig,
        notificationPaneState,
        setNotificationPaneState,
        notificationState,
        setNotificationState,
        emailAppUnreadMessagesCount,
        setEmailAppUnreadMessagesCount,
        feedbackState,
        setFeedbackState,
        copilotState,
        setCopilotState
      }}
    >
      {children}
    </NavigationContext.Provider>
  )
}
